import { render, staticRenderFns } from "./CustomerOpenTickets.vue?vue&type=template&id=eec1b9b4&scoped=true&"
import script from "./CustomerOpenTickets.vue?vue&type=script&lang=js&"
export * from "./CustomerOpenTickets.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOpenTickets.vue?vue&type=style&index=0&id=eec1b9b4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec1b9b4",
  null
  
)

export default component.exports